import { render, staticRenderFns } from "./SetPhoneModal.vue?vue&type=template&id=317eabb8&scoped=true&"
import script from "./SetPhoneModal.vue?vue&type=script&lang=js&"
export * from "./SetPhoneModal.vue?vue&type=script&lang=js&"
import style0 from "./SetPhoneModal.vue?vue&type=style&index=0&id=317eabb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317eabb8",
  null
  
)

export default component.exports